import { useAppContext } from "../../Components/AppProvider";
import "./PCPHeader.scss";
function PCPHeader() {
  const { customerfullname, customerId } = useAppContext();
  return (
    <div className="pcp-header-logo-container">
      <div className="pcp-header-login-header">WELCOME, {customerfullname}</div>
    </div>
  );
}
export default PCPHeader;
